import React from 'react';
import styles from './Header.module.scss';

export const Header = () => <div className={styles.header}>Map</div>;
